import { styled } from '@mui/system'

export const Section = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '& .con': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& img': {
      width: '30%',
      margin: theme.spacing(1, 15, 1, 1),
      [theme.breakpoints.between('sm', 'lg')]: {
        width: '40%',
        margin: theme.spacing(1, 8, 1, 1),
      },
      [theme.breakpoints.down('sm')]: {
        width: '40%',
        margin: theme.spacing(1, 5, 1, 1),
      },
    },
  },
}))